export default __webpack_public_path__ + "static/537-945008847ff5bcc1a8d3f49ad33d0a4f.gif";